import { __awaiter } from "tslib";
import { Connection, clusterApiUrl } from "@solana/web3.js";
import { getDefaultProvider } from "@ethersproject/providers";
import axios from "axios";
import config from "./config";
export const defaultResolver = {
    resolve: (did) => __awaiter(void 0, void 0, void 0, function* () {
        const resolveDidUrl = `https://did.civic.com/1.0/identifiers/${did}`;
        const response = yield axios.get(resolveDidUrl);
        return {
            didResolutionMetadata: {},
            didDocument: response.data,
            didDocumentMetadata: {},
        };
    }),
};
const defaultSolanaConnection = new Connection(clusterApiUrl("mainnet-beta"));
const defaultEthereumProvider = getDefaultProvider();
export const defaults = {
    // Resolve DID document
    resolver: defaultResolver,
    // Resolve did document if default resolver not set and sns name
    solana: {
        connection: defaultSolanaConnection,
    },
    // Used to resolve ens name
    ethereum: {
        provider: defaultEthereumProvider,
    },
    civicIdentityStoreEndpoint: config.civicIdentityStoreEndpoint,
};
// TODO: Update README.md to reflect this change
export const defaultPassOptions = {
    civicPassLookupEndpoint: config.passLookupEndpoint,
    includeTestnets: false,
    includeTestPassTypes: false,
    includeExpired: false,
};
